import jQuery from 'jquery'

export default {

    mounted () {
        this.openCustomModal()
    },

    methods: {

        openCustomModal () {
            jQuery('html').addClass('modal-open')
        },

        closeCustomModal (emitListRefresh = false) {
            this.$emit('close')
            if (emitListRefresh) {
                this.$emit('refresh')
            }
            setTimeout(function () {
                jQuery('html').removeClass('modal-open')
            }, 360)
        }

    }
}
